import React, { useState } from 'react';
import { PostResponseSchema } from '../../../../api/client';
import LoadingSpinner from '../../components/LoadingSpinner';

interface Props {
  post: PostResponseSchema;
}

export default function PostCardBackgroundImage({ post }: Props): React.ReactElement | null {
  const [imageLoading, setImageLoading] = useState(true);

  // Determine background image source (photo or video thumbnail)
  const backgroundSrc = post.photo_url_compressed || post.m3u8_url ? post.photo_url_compressed : null;

  if (!backgroundSrc) {
    return null;
  }

  return (
    <>
      {imageLoading && <LoadingSpinner />}
      <img
        src={backgroundSrc}
        alt="Post background"
        className="post-image"
        style={{
          opacity: imageLoading ? 0 : 1,
          transition: 'opacity 0.3s ease',
          pointerEvents: 'none'
        }}
        onLoad={() => setImageLoading(false)}
        onError={() => setImageLoading(false)}
      />
    </>
  );
}
